import { useState, useCallback, useRef, useMemo } from 'react';
import { Drawer, message, Button } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import {
  DeleteOutlined,
  InfoCircleOutlined,
  FileTextOutlined,
  ToolOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { updateEvent } from '../../redux/slices/eventSlice';

import SelectorItem from '../../components/SelectorItem';
import InputItem from '../../components/InputItem';
import RadioItem from '../../components/RadioItem';
import UploadItem from '../../components/UploadItem';
import TextEditor from '../../components/TextEditor';
import SaveButton from '../../components/SaveButton';

import request from '@/request';

const tabs = [
  { key: 'base', label: '基本信息', icon: InfoCircleOutlined },
  { key: 'attrs', label: '器械限制', icon: ToolOutlined },
  { key: 'rule', label: '竞赛规则', icon: FileTextOutlined },
  { key: 'appendix', label: '项目附件', icon: PaperClipOutlined },
];

function BaseInfo({ event, formData, updateField, item }) {
  let unitLabel = '';
  if (item?.contestType === 1) unitLabel = '个人';
  if (item?.contestType === 2) unitLabel = '队伍';

  return (
    <div className="space-y-6 mb-10">
      <div className="w-full flex gap-4">
        <InputItem
          label="项目类型"
          disabled
          value={formData.tplTypeName || '自定义'}
          className="w-full"
        />
        {/* <SelectorItem
          label="项目类型"
          value={formData.typeId}
          onChange={(value) => {
            updateField('typeId', value);
          }}
          options={config.itemTypes.map((i) => ({
            value: i.id,
            label: i.name,
          }))}
          className="w-full"
        /> */}
        <InputItem
          label="项目名称"
          require
          value={formData.name}
          onChange={(value) => {
            updateField('name', value);
          }}
          className="w-full"
        />
      </div>
      <div className="w-full flex gap-4">
        <RadioItem
          label="参赛形式"
          value={formData.contestType}
          options={[
            { value: 1, label: '个人赛' },
            { value: 2, label: '团队赛' },
          ]}
          className="w-full"
          // disabled={!!formData.tplTypeName}
          onChange={(value) => {
            updateField('contestType', value)
          }}
        />
        {/* <SelectorItem
          label="参赛形式"
          value={formData.contestType}
          onChange={(value) => {
            updateField('contestType', value);
          }}
          options={[
            { value: 1, label: '个人赛' },
            { value: 2, label: '团队赛' },
          ]}
          className="w-full"
          disabled={!!formData.tplTypeName}
        /> */}
        <RadioItem
          label="竞赛赛制"
          value={formData.contestFormat}
          options={[
            { value: 1, label: '竞速赛(比速度)' },
            { value: 2, label: '对抗赛(两队对抗)' },
          ]}
          className="w-full"
          // disabled={!!formData.tplTypeName}
          onChange={(value) => {
            updateField('contestFormat', value)
          }}
        />
        {/* <SelectorItem
          label="竞赛赛制"
          value={formData.contestFormat}
          onChange={(value) => {
            updateField('contestFormat', value);
          }}
          options={[
            { value: 1, label: '竞速赛(比速度)' },
            { value: 2, label: '对抗赛(两队对抗)' },
            // { value: 3, label: '评分赛(多评委打分)' },
          ]}
          className="w-full"
          disabled={!!formData.tplTypeName}
        /> */}
      </div>
      <div className="w-full flex gap-4">
        <InputItem
          label="组别类型"
          disabled
          value={formData.tplGroupName || '自定义'}
          className="w-full"
        />
        {/* <SelectorItem
          label="组别类型"
          value={formData.groupId}
          onChange={(value) => {
            updateField('groupId', value);
          }}
          options={config.groupTypes.map((i) => ({
            value: i.id,
            label: i.name,
          }))}
          className="w-full"
        /> */}
        <InputItem
          label="类型别名"
          require
          value={formData.groupName}
          onChange={(value) => {
            updateField('groupName', value);
          }}
          className="w-full"
        />
      </div>
      <div className="w-full flex gap-4">
        <InputItem
          label="最小年龄"
          type="number"
          require
          value={formData.minAge}
          onChange={(value) => {
            updateField('minAge', value);
          }}
          className="w-full"
        />
        <InputItem
          label="最大年龄"
          type="number"
          require
          value={formData.maxAge}
          onChange={(value) => {
            updateField('maxAge', value);
          }}
          className="w-full"
        />
      </div>
      <div className="w-full flex gap-4">
        <InputItem
          label="报名费"
          type="money"
          require
          value={formData.applyPrice}
          min={0}
          // disabled={event.reviewStatus === 2}
          onChange={(value) => updateField('applyPrice', value)}
          placeholder="0 表示免费，非0时最小0.01元"
          className="w-full"
        />
      </div>
      <div className="w-full flex gap-4">
        <InputItem
          label={`报名人数下限${unitLabel}`}
          type="number"
          require
          value={formData.minApply}
          // disabled={event.reviewStatus === 2}
          onChange={(value) => updateField('minApply', value)}
          placeholder={`请输入数字${unitLabel}`}
          defaultValue={2}
          className="w-full"
        />
        <InputItem
          label={`报名人数上限${unitLabel}`}
          type="number"
          require
          value={formData.maxApply}
          // disabled={event.reviewStatus === 2}
          onChange={(value) => updateField('maxApply', value)}
          placeholder={`请输入数字${unitLabel}`}
          defaultValue={100}
          className="w-full"
        />
      </div>
      {formData.contestType === 2 && (
        <div className="w-full flex gap-4">
          <InputItem
            label="队伍最少人数"
            type="number"
            require
            value={formData.minPlayer}
            // disabled={event.reviewStatus === 2}
            onChange={(value) => updateField('minPlayer', value)}
            placeholder="请输入每队最少人数"
            defaultValue={2}
            className="w-full"
          />
          <InputItem
            label="队伍最多人数"
            type="number"
            require
            value={formData.maxPlayer}
            // disabled={event.reviewStatus === 2}
            onChange={(value) => updateField('maxPlayer', value)}
            placeholder="请输入每队最多人数"
            defaultValue={3}
            className="w-full"
          />
        </div>
      )}
      <UploadItem
        require
        label="赛项封面"
        placeholder="尺寸为 500*500，支持JPG, JPEG, PNG格式的图片，最大不超过3M"
        value={formData.cover}
        onChange={(url) => updateField('cover', url)}
        demoUrl="https://statics.dronex.cc/202603031002/business/6-%E4%B8%AD.png"
      />
    </div>
  );
}

function ItemOptions({ value = [], onChange }) {
  const rows = value;
  const containerRef = useRef(null);

  const addRow = () => {
    const newRows = [
      ...rows,
      { id: Date.now() + Math.random(), key: '', value: '' },
    ];
    if (onChange) onChange(newRows);

    // 滚动到新添加的项
    setTimeout(() => {
      if (containerRef.current) {
        const lastItem = containerRef.current.lastElementChild;
        if (lastItem) {
          lastItem.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }
      }
    }, 100);
  };

  const updateRow = (index, field, val) => {
    const newRows = rows.map((r, i) =>
      i === index ? { ...r, [field]: val } : r
    );
    if (onChange) onChange(newRows);
  };

  const removeRow = (index) => {
    const newRows = rows.filter((r, i) => i !== index);
    if (onChange) onChange(newRows);
  };

  return (
    <div className="flex flex-col h-full">
      {/* 列表区域 */}
      <div className="flex-1 overflow-y-auto mb-4">
        {rows.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="w-16 h-16 mb-4 rounded-full bg-slate-100 flex items-center justify-center">
              <ToolOutlined className="text-2xl text-slate-400" />
            </div>
            <p className="text-slate-600 font-medium mb-1">暂无器械限制配置</p>
            <p className="text-sm text-slate-400">点击下方按钮添加配置项</p>
          </div>
        ) : (
          <div ref={containerRef} className="space-y-3">
            {rows.map((row, index) => (
              <div
                key={index}
                className="flex items-center gap-3 flex-nowrap bg-white p-3 rounded-lg border border-slate-200 hover:border-blue-300 hover:shadow-sm transition-all duration-200"
              >
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-slate-500 text-sm font-medium">
                  {index + 1}
                </div>
                <input
                  aria-label="限制项"
                  placeholder="如：飞手等级、器械尺寸等"
                  value={row.key}
                  onChange={(e) => updateRow(index, 'key', e.target.value)}
                  className="w-40 min-w-0 px-3 py-2 bg-slate-50 border border-slate-200 rounded-md text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <input
                  aria-label="限制值"
                  placeholder="如：L1及以上、200mm以下等"
                  value={row.value}
                  onChange={(e) => updateRow(index, 'value', e.target.value)}
                  className="flex-1 min-w-0 px-3 py-2 bg-slate-50 border border-slate-200 rounded-md text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <button
                  type="button"
                  onClick={() => removeRow(index)}
                  className="flex-shrink-0 w-8 h-8 rounded-md text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors duration-200 flex items-center justify-center cursor-pointer"
                  title="删除此项"
                >
                  <DeleteOutlined />
                </button>
              </div>
            ))}
          </div>
        )}
        <button
          type="button"
          onClick={addRow}
          className="w-full py-3 mt-3 mb-5 border-2 border-dashed border-slate-300 rounded-lg text-slate-600 hover:border-blue-500 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200 cursor-pointer font-medium flex items-center justify-center gap-2"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          添加器械限制项
        </button>
      </div>
    </div>
  );
}

export default function EditItemDrawer({ open, onClose, item, event }) {
  const [step, setStep] = useState(item?.id ? 2 : 1);
  const {
    config: { itemTypes, groupTypes },
  } = useSelector((state) => state.event);

  const [typeId, setTypeId] = useState(item?.id ? (item.typeId ?? 0) : null);
  const [groupId, setGroupId] = useState(item?.id ? (item.groupId ?? 0) : null);
  const dispatch = useDispatch();

  // 初始化表单数据
  const getInitialFormData = useCallback(() => {
    if (item?.id) {
      // 编辑模式：使用 item 的值
      return {
        name: item.name || '',
        groupName: item.groupName || '',
        applyPrice: item.applyPrice || 0,
        minApply: item.minApply || '',
        maxApply: item.maxApply || '',
        minPlayer: item.minPlayer || '',
        maxPlayer: item.maxPlayer || '',
        rule: item.rule || '',
        attrsList: item.attrsList || [],
        appendix: item.appendix || [],
        cover: item.cover || '',
        maxAge: item.maxAge || 0,
        minAge: item.minAge || 0,
        contestType: item.contestType || 0,
        contestFormat: item.contestFormat || 0,
        tplTypeName: item.tplTypeName || '',
        tplGroupName: item.tplGroupName || '',
      };
    } else {
      // 新建模式：初始化为空值
      return {
        name: '',
        groupName: '',
        applyPrice: 0,
        minApply: '',
        maxApply: '',
        minPlayer: '',
        maxPlayer: '',
        rule: '',
        attrsList: [],
        appendix: [],
        cover: '',
        contestType: 0,
        contestFormat: 0,
        maxAge: 0,
        minAge: 0,
        tplTypeName: '',
        tplGroupName: '',
      };
    }
  }, [item]);

  const [formData, setFormData] = useState(getInitialFormData);
  const [activeTab, setActiveTab] = useState('base');

  const updateField = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const getMissingFields = () => {
    const missing = [];
    if (!formData.name) missing.push('项目名称');
    if (!formData.groupName) missing.push('组别');
    if (!formData.contestType) missing.push('参赛形式');
    if (!formData.contestFormat) missing.push('竞赛赛制');
    if (
      formData.applyPrice === '' ||
      formData.applyPrice === undefined ||
      formData.applyPrice === null
    )
      missing.push('报名费');
    if (!formData.minApply) missing.push('最小申请数');
    if (!formData.maxApply) missing.push('最大申请数');

    if (formData.contestType === 2) {
      if (!formData.minPlayer) missing.push('队伍最小人数');
      if (!formData.maxPlayer) missing.push('队伍最大人数');
    }
    if (
      !formData.rule ||
      formData.rule.trim() === '' ||
      formData.rule === '<p><br></p>'
    ) {
      missing.push('竞赛规则');
    }
    if (
      !formData.attrsList ||
      formData.attrsList.length === 0 ||
      formData.attrsList.some((attr) => !attr.key || !attr.value)
    ) {
      missing.push('器械限制');
    }
    if (!formData.minAge) missing.push('最小年龄');
    if (!formData.minAge) missing.push('最大年龄');
    if (!formData.cover) missing.push('赛项封面');
    return missing;
  };

  const missingFields = getMissingFields();
  const isFormValid = useMemo(() => {
    if (step === 1) {
      return typeId !== null && groupId !== null;
    }
    return missingFields.length === 0;
  }, [typeId, groupId, step, missingFields]);

  const handleSubmit = useCallback(async () => {
    if (step === 1) {
      const template = await request.get(
        `/events/items/template?groupId=${groupId}&typeId=${typeId}`
      );
      
      /** 根据组别类型自动输入年龄 */
      const groupNames = {
        '小学组': [7, 12],
        '初中组': [12, 15],
        '高中组-含中专与职高': [15, 19],
      };

      setFormData({
        tplTypeName: typeId ? template.typeName : '',
        tplGroupName: groupId ? template.groupName : '',
        name: typeId ? template.typeName : '',
        groupName: groupId ? template.groupName : '',
        applyPrice: template.applyPrice || 0,
        minApply: template.minApply || '',
        maxApply: template.maxApply || '',
        minPlayer: template.minPlayer || '',
        maxPlayer: template.maxPlayer || '',
        rule: template.rule || '',
        attrsList: template.attrs || [],
        appendix: template.appendix || [],
        cover: template.cover || '',
        // maxAge: template.maxAge || 0,
        maxAge: template.groupName ? groupNames[template.groupName][1] : 0,
        // minAge: template.minAge || 0,
        minAge: template.groupName ? groupNames[template.groupName][0] : 0,
        contestType: template.contestType || 0,
        contestFormat: template.contestFormat || 0,
      });
      setStep(2);
      return;
    }
    
    const priceNum = Number(formData.applyPrice);
    // 验证必填项
    if (!formData.name) {
      message.error('请输入项目名称');
      throw new Error('请输入项目名称');
    }
    if (!formData.groupName) {
      message.error('请输入组别');
      throw new Error('请输入组别');
    }
    if (
      formData.applyPrice === '' ||
      formData.applyPrice === undefined ||
      formData.applyPrice === null
    ) {
      message.error('请输入报名费');
      throw new Error('请输入报名费');
    }
    if (isNaN(priceNum) || priceNum < 0) {
      message.error('报名费不能为负数');
      throw new Error('报名费不能为负数');
    }
    // 校验报名费最多2位小数
    if (priceNum && !/^\d+(\.\d{1,2})?$/.test(String(formData.applyPrice))) {
      message.error('报名费最多只能有2位小数');
      throw new Error('报名费最多只能有2位小数');
    }
    if (priceNum !== 0 && priceNum < 0.01) {
      message.error('报名费非0时必须大于等于0.01元');
      throw new Error('报名费非0时必须大于等于0.01元');
    }
    // if (priceNum <= 0.01) {
    //   message.error('报名费必须大于等于0.01元');
    //   throw new Error('报名费必须大于等于0.01元');
    // }
    if (!formData.minApply) {
      message.error('请输入最小申请数');
      throw new Error('请输入最小申请数');
    }
    if (!formData.maxApply) {
      message.error('请输入最大申请数');
      throw new Error('请输入最大申请数');
    }
    // 验证最小值必须大于0
    if (Number(formData.minApply) <= 0) {
      message.error('最小申请数必须大于0');
      throw new Error('最小申请数必须大于0');
    }
    // 验证最大值必须大于最小值
    if (Number(formData.minApply) > Number(formData.maxApply)) {
      message.error('最大申请数必须大于最小申请数');
      throw new Error('最大申请数必须大于最小申请数');
    }

    if (formData.contestType === 2) {
      if (!formData.minPlayer) {
        message.error('请输入队伍最小人数');
        throw new Error('请输入队伍最小人数');
      }
      if (!formData.maxPlayer) {
        message.error('请输入队伍最大人数');
        throw new Error('请输入队伍最大人数');
      }
      if (Number(formData.minPlayer) <= 0) {
        message.error('队伍最小人数必须大于0');
        throw new Error('队伍最小人数必须大于0');
      }
      if (Number(formData.minPlayer) > Number(formData.maxPlayer)) {
        message.error('队伍最大人数必须大于最小人数');
        throw new Error('队伍最大人数必须大于最小人数');
      }
    }

    if (
      !formData.rule ||
      formData.rule.trim() === '' ||
      formData.rule === '<p><br></p>'
    ) {
      message.error('请输入竞赛规则');
      throw new Error('请输入竞赛规则');
    }
    if (!formData.attrsList || formData.attrsList.length === 0) {
      message.error('请至少添加一项器械限制');
      throw new Error('请至少添加一项器械限制');
    }

    const params = { ...formData };

    if (!params.minPlayer) delete params.minPlayer;
    if (!params.maxPlayer) delete params.maxPlayer;
    params.attrsList = params.attrsList.map((attr) => ({
      key: attr.key,
      value: attr.value,
      sort: 0,
    }));
    params.eventId = event.id;
    params.applyPrice = Number(formData.applyPrice);
    params.typeId = typeId;
    params.groupId = groupId;

    if (item?.id) {
      // 更新
      await request.put(`/events/item/${item.id}`, params);
      message.success('更新成功');
    } else {
      // 创建
      await request.post('/events/item', params);
      message.success('创建成功');
    }
    const data = await request.get(`/events/info/${event.id}`);
    dispatch(updateEvent(data));
    if (onClose) onClose();
  }, [step, event.id, formData, item, onClose, typeId, groupId, dispatch]);

  return (
    <Drawer title="编辑竞赛项目" size={660} onClose={onClose} open={open}>
      {step === 1 && (
        <div className="flex flex-col space-y-6">
          <h2>赛项类型</h2>
          <div className="flex flex-wrap gap-4">
            {itemTypes?.map((type) => (
              <Button
                key={type.id}
                onClick={() => setTypeId(type.id)}
                type={typeId === type.id ? 'primary' : ''}
              >
                {type.name}
              </Button>
            ))}
            <Button
              key={-1}
              onClick={() => setTypeId(0)}
              type={typeId === 0 ? 'primary' : ''}
            >
              自定义
            </Button>
          </div>
          <h2>组别类型</h2>
          <div className="flex flex-wrap gap-4">
            {groupTypes?.map((type) => (
              <Button
                key={type.id}
                onClick={() => setGroupId(type.id)}
                type={groupId === type.id ? 'primary' : ''}
              >
                {type.name}
              </Button>
            ))}
            <Button
              key={-1}
              onClick={() => setGroupId(0)}
              type={groupId === 0 ? 'primary' : ''}
            >
              自定义
            </Button>
          </div>
        </div>
      )}
      {step === 2 && (
        <>
          <div className="flex border-b border-slate-200">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`flex-1 pb-3 text-center transition-colors cursor-pointer ${activeTab === tab.key
                    ? 'text-blue-600 border-b-2 border-blue-600 font-medium'
                    : 'text-slate-600 hover:text-blue-600'
                    }`}
                >
                  <div className="flex items-center justify-center gap-2">
                    <Icon className="text-base" />
                    <span>{tab.label}</span>
                  </div>
                </button>
              );
            })}
          </div>

          {/* 中部：可滚动内容区 */}
          <div className="flex-1 overflow-y-auto py-4">
            {activeTab === 'base' && (
              <BaseInfo
                formData={formData}
                updateField={updateField}
                event={event}
                item={item}
              />
            )}
            {activeTab === 'attrs' && (
              <ItemOptions
                value={formData.attrsList}
                onChange={(value) => updateField('attrsList', value)}
              />
            )}
            {activeTab === 'rule' && (
              <div className="pb-8">
                <TextEditor
                  value={formData.rule}
                  onChange={(v) => updateField('rule', v)}
                  placeholder="请输入竞赛规则..."
                />
              </div>
            )}
            {activeTab === 'appendix' && (
              <UploadItem
                label="上传项目附件"
                multiple
                value={formData.appendix}
                onChange={(files) => updateField('appendix', files)}
                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                placeholder="请点击或拖拽文件至改区域进行上传"
              />
            )}
          </div>
        </>
      )}
      <div className="fixed bottom-0 right-0 flex justify-between items-center w-[660px] bg-white p-4 border-t border-slate-200">
        {!isFormValid && (
          <div className="flex items-center gap-2 text-orange-600">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            {step === 1 && (
              <span className="text-sm">请选择赛项类型和组别类型</span>
            )}
            {step === 2 && (
              <span className="text-sm">
                请完善必填项：{missingFields.join('、')}
              </span>
            )}
          </div>
        )}
        {isFormValid && <div />}
        <SaveButton
          text={step === 1 ? '下一步' : item?.id ? '更新项目' : '创建项目'}
          onSave={handleSubmit}
          disabled={!isFormValid}
        />
      </div>
    </Drawer>
  );
}
